import { c as _c } from "react/compiler-runtime";
// Разделённые платежи (ТЗ п. 1.2, 31.10.2026): состояние и счета получателей.
//
// Карточка в «Финансах» рядом с выплатами: при включённом флаге оплата
// заказа делится провайдером между магазинами продавцов и площадкой, и
// выплата по графику за такой заказ уже не нужна. Здесь заводится счёт
// получателя магазина — его магазин в Робокассе.
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@osmix/ui/badge";
import { Button } from "@osmix/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@osmix/ui/card";
import { Input } from "@osmix/ui/input";
import { formatPrice } from "@/lib/utils";
import { paymentsAdminAvailable, useSplitAccountRemove, useSplitAccountSave, useSplitStatus } from "@/pages/payments-api";
export function SplitPaymentsCard(t0) {
  const $ = _c(46);
  const {
    canManage
  } = t0;
  const {
    t
  } = useTranslation();
  const status = useSplitStatus();
  const save = useSplitAccountSave();
  const remove = useSplitAccountRemove();
  const [shopId, setShopId] = useState("");
  const [merchantId, setMerchantId] = useState("");
  if (!paymentsAdminAvailable || !status.data) {
    return null;
  }
  const data = status.data;
  const error = save.error ?? remove.error;
  let t1;
  if ($[0] !== t) {
    t1 = t("paymentRefunds.split.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = data.enabled ? "default" : "outline";
  let t3;
  if ($[2] !== data.provider || $[3] !== t2) {
    t3 = <Badge variant={t2}>{data.provider}</Badge>;
    $[2] = data.provider;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <CardTitle className="flex flex-wrap items-center gap-2 text-base">{t1}{t3}</CardTitle>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== data.enabled || $[9] !== data.platformMerchantId || $[10] !== t) {
    t5 = data.enabled ? t("paymentRefunds.split.on", {
      master: data.platformMerchantId
    }) : t("paymentRefunds.split.off");
    $[8] = data.enabled;
    $[9] = data.platformMerchantId;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <p className="text-sm text-muted-foreground">{t5}</p>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <CardHeader className="gap-1 pb-2">{t4}{t6}</CardHeader>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("paymentRefunds.split.hint");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <p className="text-xs text-muted-foreground">{t8}</p>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== data.settledToShops || $[22] !== t) {
    t10 = data.settledToShops > 0 && <p>{t("paymentRefunds.split.settled", {
        amount: formatPrice(data.settledToShops)
      })}</p>;
    $[21] = data.settledToShops;
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== canManage || $[25] !== data.accounts || $[26] !== remove || $[27] !== t) {
    t11 = data.accounts.length === 0 ? <p className="text-muted-foreground">{t("paymentRefunds.split.empty")}</p> : <ul className="flex flex-col divide-y rounded-md border">{data.accounts.map(a => <li key={a.shopId} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2"><span className="min-w-0 [overflow-wrap:anywhere]"><span className="font-medium">{a.shopId}</span><span className="text-muted-foreground"> → {a.merchantId}</span><span className="ml-2 whitespace-nowrap text-xs text-muted-foreground">{t(a.status === "active" ? "paymentRefunds.split.active" : "paymentRefunds.split.disabled")}</span></span>{canManage && <Button size="sm" variant="ghost" disabled={remove.isPending} onClick={() => remove.mutate(a.shopId)}>{t("paymentRefunds.split.remove")}</Button>}</li>)}</ul>;
    $[24] = canManage;
    $[25] = data.accounts;
    $[26] = remove;
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== canManage || $[30] !== merchantId || $[31] !== save || $[32] !== shopId || $[33] !== t) {
    t12 = canManage && <form className="flex flex-col gap-2 sm:flex-row sm:items-end" onSubmit={e => {
      e.preventDefault();
      if (!shopId.trim() || !merchantId.trim()) {
        return;
      }
      save.mutate({
        shopId: shopId.trim(),
        merchantId: merchantId.trim()
      }, {
        onSuccess: () => {
          setShopId("");
          setMerchantId("");
        }
      });
    }}><label className="flex min-w-0 flex-1 flex-col gap-1"><span className="text-xs text-muted-foreground">{t("paymentRefunds.split.shop")}</span><Input value={shopId} onChange={e_0 => setShopId(e_0.target.value)} data-testid="split-shop" /></label><label className="flex min-w-0 flex-1 flex-col gap-1"><span className="text-xs text-muted-foreground">{t("paymentRefunds.split.merchant")}</span><Input value={merchantId} onChange={e_1 => setMerchantId(e_1.target.value)} data-testid="split-merchant" /></label><Button type="submit" disabled={save.isPending || !shopId.trim() || !merchantId.trim()}>{t("paymentRefunds.split.add")}</Button></form>;
    $[29] = canManage;
    $[30] = merchantId;
    $[31] = save;
    $[32] = shopId;
    $[33] = t;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== error) {
    t13 = error && <p className="text-xs text-destructive">{error.message}</p>;
    $[35] = error;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t13 || $[41] !== t9) {
    t14 = <CardContent className="flex flex-col gap-3 text-sm">{t9}{t10}{t11}{t12}{t13}</CardContent>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t13;
    $[41] = t9;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t14 || $[44] !== t7) {
    t15 = <Card data-testid="split-payments">{t7}{t14}</Card>;
    $[43] = t14;
    $[44] = t7;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  return t15;
}